export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-A-5bc15655b406b83dfe96122c367dd5c5.jpg";